import script from "./AccordionContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccordionContainer.vue?vue&type=script&setup=true&lang=ts"

import "./AccordionContainer.vue?vue&type=style&index=0&id=460d4806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460d4806"]])

export default __exports__